import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/callback')({
  component: CallbackPage,
})

function CallbackPage() {
  // The AuthProvider's onSigninCallback handles the redirect.
  // This component just shows a loading state while that happens.
  return (
    <div className="flex h-screen items-center justify-center">
      <div className="text-muted-foreground text-sm">Completing sign in...</div>
    </div>
  )
}
